module.exports = __webpack_public_path__ + "static/img/app-introduction-icons.76e55c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/app-introduction-icons.png
// module id = YFqW
// module chunks = 0